// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cMuEcHgSAv0NniBkv8Yw{width:100%;padding:12px}.YMGAmBiE8AwxQl8xmmLR{border-bottom:1px solid var(--border-neutral-secondary);padding:3.5px 8px}.eVMzazMBgDk49bivpRlF{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputTimePicker": `cMuEcHgSAv0NniBkv8Yw`,
	"searchInputWrap": `YMGAmBiE8AwxQl8xmmLR`,
	"timePickerActions": `eVMzazMBgDk49bivpRlF`
};
export default ___CSS_LOADER_EXPORT___;
